import React from 'react';
import { ui, msgColor } from '../../styles/shared';
import { Device } from '../../types';

// Stilar från den gemensamma stilfilen
const card = ui.card;
const btn = ui.btn;
const inputStyle = ui.input;
const labelStyle = ui.label;
const hintStyle = ui.hint;

interface Props {
    device: Device;
    settingsForm: Record<string, string>;
    settingsSaving: boolean;
    settingsMsg: string | null;
    onIoOutput: (endpoint: number, state: 'ON' | 'OFF') => void;
    onSettingsChange: (fn: (prev: Record<string, string>) => Record<string, string>) => void;
    onSaveSettings: (payload: Record<string, any>) => void;
}

const IoModuleControl: React.FC<Props> = ({
    device, settingsForm, settingsSaving, settingsMsg,
    onIoOutput, onSettingsChange, onSaveSettings,
}) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div style={card}>
            <h3 style={{ marginTop: 0 }}>⚙️ Kanaler på IO-modulen</h3>
            {device.io_channels && Object.keys(device.io_channels).length > 0 ? (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                    {Object.entries(device.io_channels).sort(([a],[b]) => a.localeCompare(b)).map(([ch, val]) => {
                        const epNum = Number(ch.replace('ch_', ''));
                        const isOutput = epNum >= 116;
                        const label = isOutput ? `Utgång ${epNum - 115}` : `Ingång ${epNum - 111}`;
                        return (
                            <div key={ch} style={{
                                padding: '12px 16px', borderRadius: '8px', minWidth: '120px',
                                backgroundColor: val ? '#d4edda' : '#f8f9fa',
                                border: `1px solid ${val ? '#28a745' : '#ddd'}`, textAlign: 'center',
                            }}>
                                <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{label}</div>
                                <div style={{ fontSize: '12px', color: '#888', marginBottom: '6px' }}>{ch} (ep{epNum})</div>
                                <div style={{ fontSize: '18px', fontWeight: 'bold', color: val ? '#28a745' : '#999' }}>{val ? 'PÅ' : 'AV'}</div>
                                {isOutput && (
                                    <div style={{ marginTop: '8px', display: 'flex', gap: '6px', justifyContent: 'center' }}>
                                        <button onClick={() => onIoOutput(epNum, 'ON')}
                                            style={{ padding: '4px 10px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>PÅ</button>
                                        <button onClick={() => onIoOutput(epNum, 'OFF')}
                                            style={{ padding: '4px 10px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>AV</button>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            ) : (
                <p style={{ color: '#888' }}>Inga kanalvärden ännu. Väntar på första avläsningen…</p>
            )}
        </div>

        <div style={card}>
            <h3 style={{ marginTop: 0 }}>⚙️ Inställningar</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', maxWidth: '400px' }}>
                <div>
                    <label style={labelStyle}>Hur ofta kanalerna läses av (sekunder)</label>
                    <input type="number" min="5" max="3600" step="5" placeholder="60"
                        value={settingsForm.poll_interval ?? ''}
                        onChange={e => onSettingsChange(p => ({ ...p, poll_interval: e.target.value }))}
                        style={inputStyle} />
                    <span style={hintStyle}>Hur ofta alla kanaler läses av. Standard: 60 s.</span>
                </div>
                <button disabled={settingsSaving}
                    onClick={() => {
                        const payload: Record<string, any> = {};
                        if (settingsForm.poll_interval) payload.poll_interval = Number(settingsForm.poll_interval);
                        onSaveSettings(payload);
                    }}
                    style={{ ...btn(settingsSaving ? '#6c757d' : '#28a745'), cursor: settingsSaving ? 'not-allowed' : 'pointer', alignSelf: 'flex-start' }}>
                    {settingsSaving ? 'Sparar…' : 'Spara'}
                </button>
                {settingsMsg && <p style={{ margin: 0, fontSize: '14px', color: msgColor(settingsMsg) }}>{settingsMsg}</p>}
            </div>
        </div>
    </div>
);

export default IoModuleControl;
